import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import Overlay from 'components/Overlay';

const UpsellError = ({
  backgroundClass,
  backgroundUrl,
  children,
  innerContainerChildren,
  innerContainerChildrenParams,
  rendered,
  sharedTheme,
  theme,
}) => (
  <Overlay
    backgroundClass={backgroundClass}
    backgroundUrl={backgroundUrl}
    sharedTheme={sharedTheme}
    theme={theme}
    rendered={rendered}
    innerContainerChildren={innerContainerChildren}
    innerContainerChildrenParams={innerContainerChildrenParams}
  >
    <div className={classNames(sharedTheme.innerContainer, theme.innerContainer)}>{children}</div>
  </Overlay>
);

UpsellError.defaultProps = {
  backgroundUrl: null,
  sharedTheme: {},
};

UpsellError.propTypes = {
  backgroundClass: PropTypes.string,
  backgroundUrl: PropTypes.string,
  children: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node]),
  innerContainerChildren: PropTypes.func,
  innerContainerChildrenParams: PropTypes.shape({}),
  rendered: PropTypes.bool,
  sharedTheme: PropTypes.shape({}),
  theme: PropTypes.shape({}),
};

UpsellError.defaultProps = {
  backgroundClass: null,
  backgroundUrl: null,
  children: null,
  innerContainerChildren: () => {},
  innerContainerChildrenParams: {},
  rendered: false,
  sharedTheme: {},
  theme: {},
};

export default UpsellError;
